import { Component, OnInit, AfterViewInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ChatService } from '../../services/chat.service';
declare var JitsiMeetExternalAPI: any;

@Component({
    selector: 'app-jitsi',
    templateUrl: './jitsi.component.html',
    styleUrls: ['./jitsi.component.scss']
})
export class JitsiComponent implements OnInit, AfterViewInit {

    domain: string = "meet.pismo-fsin.ru";
    @Input() room: string;
    @Input() name: string;
    options: any;
    api: any;
    user: any;

    // For Custom Controls
    isAudioMuted = false;
    isVideoMuted = false;

    constructor(
        private router: Router,
        private chatService: ChatService
    ) { }

    ngOnInit(): void {
        this.user = {
            name: this.name // set your username
        }
    }

    ngAfterViewInit(): void {
      const heigthWindow = window.innerHeight - 20;
      const widthWindow = window.innerWidth - 20;

      this.options = {
            roomName: this.room,
            configOverwrite: {
            enableNoAudioDetection: true,
            enableNoisyMicDetection: true,
            prejoinConfig: {
              enabled: false,
              hideDisplayName: true,
              hideExtraJoinButtons: ['by-phone'],// 'no-audio',
            },
            requireDisplayName: false,
            welcomePage: {
              //     Отключать ли страницу приветствия. Если он отключен, случайная комната
              // будут объединены, если комната не указана.
              disabled: true,
              //     Если установлено, целевая страница будет перенаправляться на этот URL.
              //     customUrl: ''
            },
            // Configs for the lobby screen.
            lobby: {
              //     // If Lobby is enabled, it starts knocking automatically. Replaces `autoKnockLobby`.
              //     autoKnock: false,
              //     // Enables the lobby chat. Replaces `enableLobbyChat`.
              enableChat: false,
            },
            // Configs for the security related UI elements.
            securityUi: {
              //     // Hides the lobby button. Replaces `hideLobbyButton`.
              hideLobbyButton: true,
              //     // Hides the possibility to set and enter a lobby password.
              disableLobbyPassword: true,
            },
            disableShortcuts: true,
            defaultLanguage: 'ru',
            disableProfile: false,
            disableDeepLinking: true,
            // Если включена интеграция с etherpad, установка значения true приведет к
            // автоматически открывать etherpad при присоединении участника. Этот
            // не влияет на мобильное приложение с момента открытия etherpad
            // скрывает элементы управления конференцией -- лучше позволить пользователям
            openSharedDocumentOnJoin: false,
            toolbarButtons: [
              'camera',
              //    'chat',
              //    'closedcaptions',
              //    'desktop',
              //    'download',
              //    'embedmeeting',
              //    'etherpad',
              //    'feedback',
              //    'filmstrip',
              'fullscreen',
              'hangup',
              //    'help',
              //    'highlight',
              //    'invite',
              //    'linktosalesforce',
              //    'livestreaming',
              'microphone',
              //    'noisesuppression',
              //    'participants-pane',
              //    'profile',
              //    'raisehand',
              //    'recording',
              //    'security',
              //    'select-background',
              //    'settings',
              //    'shareaudio',
              //    'sharedvideo',
              //    'shortcuts',
              //    'stats',
              //    'tileview',
              //    'toggle-camera',
              'videoquality',
              //    'whiteboard',
            ],
            disabledNotifications: [
              'notify.grantedTo'
            ],
            // Список кнопок экранов перед встречей, которые нужно скрыть. Значения должны быть одной или несколькими из 5 разрешенных кнопок:
            hiddenPremeetingButtons: [ 'select-background', 'invite', 'settings'],
            // Массив с пользовательскими кнопками выбора для контекстного меню участника
            // тип: Array<{ icon: string; идентификатор: строка; текст: строка; }>
            // customParticipantMenuButtons: [],

            // Массив с пользовательскими кнопками выбора для панели инструментов
            // тип: Array<{ icon: string; идентификатор: строка; текст: строка; }>
            // customToolbarButtons: [],
            // Privacy
            //

            // If third party requests are disabled, no other server will be contacted.
            // This means avatars will be locally generated and callstats integration
            // will not function.
            // disableThirdPartyRequests: false,


            // Peer-To-Peer mode: used (if enabled) when there are just 2 participants.
            //
            hideLogo: true,
            // Отключает все функции приглашения из приложения (поделиться, пригласить, позвонить... и т. д.)
            disableInviteFunctions: true,
            doNotStoreRoom: true,
            breakoutRooms: {
              hideAddRoomButton: true,
              hideAutoAssignButton: true,
              hideJoinRoomButton: true,
            },
            disableVirtualBackground: true,
            disableAddingBackgroundImages: true,
            SHOW_JITSI_WATERMARK: false,
          },
          interfaceConfigOverwrite: {
            HIDE_INVITE_MORE_HEADER: true,
            HIDE_DEEP_LINKING_LOGO: true,
            MOBILE_APP_PROMO: false,
            SHOW_JITSI_WATERMARK: false,
            SHOW_POWERED_BY: false,
            SHOW_PROMOTIONAL_CLOSE_PAGE: false,
            UNSUPPORTED_BROWSERS: [],
            // Names of browsers which should show a warning stating the current browser
            // has a suboptimal experience. Browsers which are not listed as optimal or
            // unsupported are considered suboptimal. Valid values are:
            // chrome, chromium, edge, electron, firefox, nwjs, opera, safari
            // OPTIMAL_BROWSERS: [ 'chrome', 'chromium', 'firefox', 'nwjs', 'electron', 'safari' ],
              // overwrite interface properties
          },
          parentNode: document.querySelector('#jitsi-iframe'),
          userInfo: {
              displayName: this.user.name
          }
        }
      /*// Временная обратная совместимость со старыми мобильными клиентами.
      config.flags = config.flags || {};
      config.flags.sourceNameSignaling = true;
      config.flags.sendMultipleVideoStreams = true;
      config.flags.receiveMultipleVideoStreams = true;*/

        this.api = new JitsiMeetExternalAPI(this.domain, this.options);

        this.api.addEventListeners({
            readyToClose: this.handleClose,
            participantLeft: this.handleParticipantLeft,
            participantJoined: this.handleParticipantJoined,
            videoConferenceJoined: this.handleVideoConferenceJoined,
            videoConferenceLeft: this.handleVideoConferenceLeft,
            audioMuteStatusChanged: this.handleMuteStatus,
            videoMuteStatusChanged: this.handleVideoStatus
        });

        this.frameStyle();
    }


    handleClose = (x: any) => {
        console.log("handleClose", x);
        this.chatService.callEnd();
        this.chatService.chatCloseMessage();
    }




    handleParticipantLeft = async (participant: any) => {
        console.log("handleParticipantLeft", participant); // { id: "2baa184e" }
        const data = await this.getParticipants();
    }

    handleParticipantJoined = async (participant: any) => {
        console.log("handleParticipantJoined", participant); // { id: "2baa184e", displayName: "Shanu Verma", formattedDisplayName: "Shanu Verma" }
        const data = await this.getParticipants();
    }

    handleVideoConferenceJoined = async (participant: any) => {
        console.log("handleVideoConferenceJoined", participant); // { roomName: "bwb-bfqi-vmh", id: "8c35a951", displayName: "Akash Verma", formattedDisplayName: "Akash Verma (me)"}
        const data = await this.getParticipants();
    }

    handleVideoConferenceLeft = () => {
        console.log("handleVideoConferenceLeft");
    }

    handleMuteStatus = (audio: any) => {
        console.log("handleMuteStatus", audio); // { muted: true }
    }

    handleVideoStatus = (video: any) => {
        console.log("handleVideoStatus", video); // { muted: true }
    }

    getParticipants() {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                resolve(this.api.getParticipantsInfo()); // get all participants
            }, 500)
        });
    }

    // custom events
    executeCommand(command: string) {
        this.api.executeCommand(command);;
        if(command == 'hangup') {
            this.router.navigate(['/thank-you']);
            return;
        }

        if(command == 'toggleAudio') {
            this.isAudioMuted = !this.isAudioMuted;
        }

        if(command == 'toggleVideo') {
            this.isVideoMuted = !this.isVideoMuted;
        }
    }

    frameStyle() {
      let iframeLink = document.createElement("link");

      iframeLink.href = "assets/style/fileName.css"; // css файл для iFrame
      iframeLink.rel = "stylesheet";
      iframeLink.type = "text/css";

      /*let frames = document.querySelector("iframe");
      // @ts-ignore
      frames[0].document.head.appendChild(iframeLink);*/
    }
}
